<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate="Settings.Requests"></h3>
    </div>
</div>
<div class="px-4 my-2 mb-1 d-table col-12">
    <span class="pt-5 pb-2 col-12" translate="Settings.ApplicationRequestSection.AvailableRequestTitle"></span>


    <ng-container *ngIf="allowedWorkflowSettings && allowedWorkflowSettings.length >0">

        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <ul class="mt-2 w-100 list-group">
                <ng-container *ngFor="let combo of settingsAndPermissionCombo">
                    <app-hide-by-permission-wrapper [forPermission]="combo.permissionName">
                        <li class="list-group-item d-block py-1">
                            <div class="row w-100 d-flex align-items-center">
                                <div class="col">
                                    <div class="row w-100 d-flex align-items-center">
                                        <div class="col-12 text-truncate float-none form-check form-switch">
                                            <app-permissioned-switch [forPermission]="combo.permissionName"
                                                [myValue]="getSetting(combo.settingName)" [givenId]="combo.settingName"
                                                (valueSwitched)="update(combo.settingName,$event)">
                                            </app-permissioned-switch>
                                            <label [for]="combo.settingName" class="form-check-label col-10"
                                                translate="Permissions.Names.{{combo.permissionName}}"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </app-hide-by-permission-wrapper>
                </ng-container>
            </ul>
        </div>
    </ng-container>



</div>